import { ICellEditorAngularComp } from '@ag-grid-community/angular';
import { ICellEditorParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { FormControl } from '@angular/forms';

import {
  ExtendableDropdownOption,
  ExtendableOptionsDropdownComponent,
} from '@shared/components/extendable-options-dropdown/extendable-options-dropdown.component';

export interface AgAttributeDropdownCustomParams {
  items: () => Signal<ExtendableDropdownOption[]>;
  onAddOption: (option: ExtendableDropdownOption) => void;
}

interface AgAttributeDropdownParams extends AgAttributeDropdownCustomParams, ICellEditorParams {}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'w-full block h-full',
  },
  imports: [ExtendableOptionsDropdownComponent],
  selector: 'aux-ag-attribute-dropdown',
  styleUrls: ['ag-attribute-dropdown.component.scss'],
  templateUrl: 'ag-attribute-dropdown.component.html',
})
export class AgAttributeDropdownComponent implements ICellEditorAngularComp {
  formControl = new FormControl('');
  initialSearchTerm = '';
  items?: Signal<ExtendableDropdownOption[]>;
  params!: AgAttributeDropdownParams;

  agInit(params: AgAttributeDropdownParams): void {
    this.params = params;
    this.initialSearchTerm =
      typeof params.eventKey === 'string'
        ? params.eventKey.length === 1
          ? params.eventKey
          : ''
        : '';

    this.formControl.setValue(params.value || null);
    this.items = params.items();
  }

  getValue(): string {
    return this.formControl.value ?? '';
  }

  onAddOption(option: ExtendableDropdownOption): void {
    this.params.onAddOption(option);
    this.formControl.setValue(option.value);
  }

  refresh(): boolean {
    return true;
  }

  stopEditing(): void {
    this.params.api.stopEditing();
    this.params.api.setFocusedCell(this.params.rowIndex, this.params.column.getColId());
  }
}
